import ssAxios from './SSAxios'
import Vue from 'vue'

const self = Vue.prototype

export default {

    getProductTypes() {
        return new Promise((resolve, reject) => {
            ssAxios.httpClient.post(self.$apiRouter.ssProductTypes)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }
}